import { deDE, enUS, esES, frFR, nlNL } from '@mui/x-date-pickers/locales'

import { isKnownLocale, type Locale } from '@front/translations'

const PICKER_LOCALE_BUNDLE = {
  fr: frFR,
  en: enUS,
  de: deDE,
  es: esES,
  nl: nlNL,
} satisfies Record<Locale, typeof enUS>

export const getPickerLocaleText = (language: string) => {
  const baseLanguage = language.split('-')[0]

  return (
    isKnownLocale(baseLanguage) ? PICKER_LOCALE_BUNDLE[baseLanguage] : frFR
  ).components.MuiLocalizationProvider.defaultProps.localeText
}
